import axios from 'axios';

export default class UserService {
  get URL() {
    return process.env.VUE_APP_WEB_API_URL;
  }

  get ApiUrl() {
    return process.env.VUE_APP_WEB_API_HOST;
  }

  constructor() {}

  getUserInfo() {
    return axios.get(this.URL + 'user/', {});
  }
  /*
    createExportTask(transportationServices, objectsTypes, tariffs) {
        return axios.post(this.URL + '/SaveExportTask', { transportationServicesIds: transportationServices, objectsIds: objectsTypes, tariffIds: tariffs });
    }

    getAsynchronousTasks(pageIndex, pageSize) {
        return axios.post(this.URL + '/GetExportTasks', { pageIndex: pageIndex, pageSize: pageSize });
    }*/
  
  impersonate(companyId){
    return axios.get(this.URL + `user/impersonate/${encodeURIComponent(companyId)}`);
  }

  checkUserEmail(email) {
    return axios.get(
      this.URL + `login/checkEmail?email=${encodeURIComponent(email)}`
    );
  }

  sendRegistrationEmail(email) {
    return axios.post(
      this.URL +
        `login/sendRegistrationEmail?email=${encodeURIComponent(email)}`
    );
  }

  sendLoginEmail(email) {
    return axios.post(
      this.URL + `login/sendLoginEmail?email=${encodeURIComponent(email)}`
    );
  }

  getRegistrationInitialInfo() {
    return axios.get(this.URL + `login/registrationInfo`);
  }

  resendEmail(email) {
    return axios.post(
      this.URL + `login/resendEmail?email=${encodeURIComponent(email)}`
    );
  }

  checkLoginToken(token) {
    return axios.post(this.URL + `login/token`, { token });
  }

  checkCompanyInformation(companyId) {
    return axios.post(this.URL + `login/getCompany?companyId=${companyId}`);
  }

  updateRegistrationInformation(
    firstName,
    lastName,
    password,
    branch,
    department
  ) {
    const model = {
      firstName,
      lastName,
      password,
      branch,
      department
    };

    return axios.post(`${this.URL}login/updateRegistrationInformation`, model);
  }

  loginUser(Login, Password) {
    return axios.post(`${this.URL}login/login`, { Login, Password });
  }

  loginUserById(UserId) {
    return axios.post(`${this.URL}login/getLoginTokenForUserId`, {
      UserId
    });
  }
}
